export default "__VITE_ASSET__BhqiHfdq__"